import { render, staticRenderFns } from "./RequestRejectReopen.vue?vue&type=template&id=28f9e3e7&"
import script from "./RequestRejectReopen.vue?vue&type=script&lang=js&"
export * from "./RequestRejectReopen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QCheckbox,QSpace,QBtn,QTooltip,QInput} from 'quasar'
component.options.components = Object.assign({QItem,QCheckbox,QSpace,QBtn,QTooltip,QInput}, component.options.components || {})
